module.exports = __webpack_public_path__ + "assets/img/r1.f3daea44.png";